/**
 * Ключи телеметрии по блоку пустой выдачи.
 */
export const EMPTY_STATE_TELEMETRY = {
  /** Показ виджета пустой выдачи */
  widgetShown: 'serp.empty-state.widget.shown',
  /** Клик по тегу сброса фильтра */
  tagClick: 'serp.empty-state.tag.click',
  /** Микрофронт фильтров не смог применить jsonQuery тега */
  tagApplyError: 'serp.empty-state.tag.apply-error',
  /** Обещанное на кнопке количество совпало с фактическим */
  countMatched: 'serp.empty-state.count.matched',
  /** Обещанное на кнопке количество не совпало с фактическим */
  countMismatched: 'serp.empty-state.count.mismatched',
} as const;
